import { AxiosInstance } from 'axios'
import { MediaObject } from '../types'

export interface GetSpecialistPageBlockArgs {
  locale: string
}

export type SpecialistPageBlock = {
  data: {
    attributes: {
      academic_titles_title: string
      book_now_button_text: string
      contact_us_text: string
      education_title: string
      read_more_button_text: string
      reels_title: string
      reviews_title: string
      send_button_text: string
      services_title: string
      specialization_title: string
      work_experience_title: string
      contact_us_image: MediaObject | null
    }
  }
}

export const getSpecialistPageBlock = async (client: AxiosInstance, { locale }: GetSpecialistPageBlockArgs) => {
  const path = `/specialist-page-block`
  const params = {
    locale,
    populate: '*',
  }
  return (await client.get<SpecialistPageBlock>(path, { params })).data.data.attributes
}
